var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border border-gray-200 shadow-sm bg-white",class:{
    'rounded-xl': !_vm.compact,
    rounded: _vm.compact
  }},[(_vm.title)?_c('header',{staticClass:"text-2xl text-indigo-800 font-light",class:{
      'px-8 pt-8 rounded-t-xl': !_vm.compact,
      'px-2 pt-2 rounded-t': _vm.compact
    }},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('article',{class:{ 'm-8': !_vm.compact, 'm-2': _vm.compact }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }